import React from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// Assuming keel is imported correctly
// import keel from "../../assest/images/Keel.png";
import keel from "../../assest/LogoAndFavicon/everguardlogo.png";
// import bgTemplate from "../../assest/background.png";
 import bgTemplate from "../../assest/LogoAndFavicon/background/evergaurdbg3.png";
//import bgTemplate from "../../assest/LogoAndFavicon/background/cyberguardbackground.png";
import { Box } from "@mui/material";

const ReusablePDFLayout = ({ children }) => {
  return (
    <div
      style={{
        width: "210mm", // A4 width
        height: "297mm", // A4 height
        padding: "10mm 0mm", // Padding to maintain spacing inside
        boxShadow: "0px 0px 5px rgba(0,0,0,0.2)", // Optional shadow
        backgroundImage: `url(${bgTemplate})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover", // or "contain" based on your layout
      }}
    >
      <div
        style={{
          paddingTop: "20mm",
        }}
      >

        {children}
        
      </div>
    </div>
  );
};

export default ReusablePDFLayout;
